import { Injectable } from '@angular/core';
import { HttpService } from '@app/core/http/http.service';
import { Observable } from 'rxjs';

@Injectable()
export class WelcomeMessageService {

  private sApiSupportMessages = '/api/administration/support-messages';
  private sApiWelcomeMessageStatus = '/api/User/welcome-message/status';

  constructor(private httpService: HttpService) { }

  public get(): Observable<string> {
    return this.httpService.get<string>(this.sApiSupportMessages);
  }

  public save(newWelcomeMessage: string): Observable<string> {
		return this.httpService.post<string>(this.sApiSupportMessages, JSON.stringify(newWelcomeMessage));
  }

  public setMessageAsRead(welcomeMessageStatus: string): Observable<string> {
    return this.httpService.put<string>(this.sApiWelcomeMessageStatus, JSON.stringify(welcomeMessageStatus));
  }
}
